import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { IOException1wyutdmfe71nu as IOException } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import {
  add2suhfggl4zvkk as add,
  fromInt2ii0rejb1w62w as fromInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { indexOf29nspdgx2e3ap as indexOf } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { flushIfNeededyux8o68tvpw5 as flushIfNeeded } from './ByteWriteChannel.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { writeByte1kdn4bvj0qg04 as writeByte } from './ByteWriteChannelOperations.mjs';
import { get_ONEazvfdh9ju3d4 as get_ONE } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/boxedLong/boxedLong.mjs';
import { decodeToString2ede220pr5xir as decodeToString } from '../../../../../kotlinx-io-kotlinx-io-bytestring/kotlinx/io/bytestring/ByteString.mjs';
import { replace3le3ie7l9k8aq as replace } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_findNext__stdkn8($this, ignoreMissing, $completion) {
  $this.a4k_1 = 0n;
  $l$loop: while (true) {
    var tmp;
    if (!$this.x4j_1.z3x()) {
      tmp = true;
    } else {
      var tmp_0 = $this.t4j_1.q4j(VOID, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      tmp = tmp_0;
    }
    if (!tmp) {
      break $l$loop;
    }
    var tmp_1 = advanceToNextPotentialMatch($this, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp_2 = checkFullMatch($this, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    if (tmp_2) {
      return $this.a4k_1;
    }
  }
  if (!ignoreMissing) {
    throw IOException().s4h('Expected "' + toSingleLineString($this, $this.u4j_1) + '" but encountered end of input');
  }
  $this.a4k_1 = add($this.a4k_1, $this.z4j_1.v4f($this.v4j_1.k4j()));
  var tmp_3 = $this.v4j_1.v4i($completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return $this.a4k_1;
}
function buildPartialMatchTable($this) {
  var table = new Int32Array($this.u4j_1.v2());
  var j = 0;
  var inductionVariable = 1;
  var last = $this.u4j_1.v2();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      while (j > 0 && !($this.u4j_1.w2(i) === $this.u4j_1.w2(j))) {
        j = table[j - 1 | 0];
      }
      if ($this.u4j_1.w2(i) === $this.u4j_1.w2(j)) {
        j = j + 1 | 0;
      }
      table[i] = j;
    }
     while (inductionVariable < last);
  return table;
}
function *_generator_advanceToNextPotentialMatch__2ypy7x($this, $completion) {
  $l$loop: while (true) {
    var tmp;
    if (!$this.x4j_1.z3x()) {
      tmp = true;
    } else {
      var tmp_0 = $this.t4j_1.q4j(VOID, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      tmp = tmp_0;
    }
    if (!tmp) {
      break $l$loop;
    }
    var nextMatch = indexOf($this.x4j_1, $this.u4j_1.w2(0));
    if (nextMatch === -1n) {
      var tmp_1 = $this.x4j_1;
      checkBounds($this, (tmp_1 instanceof Buffer() ? tmp_1 : THROW_CCE()).v2());
      $this.a4k_1 = add($this.a4k_1, $this.x4j_1.v4f($this.v4j_1.k4j()));
      var tmp_2 = flushIfNeeded($this.v4j_1, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
    } else {
      checkBounds($this, nextMatch);
      var tmp_3 = $this;
      var tmp_4 = $this.a4k_1;
      var tmp_5 = $this.v4j_1.k4j();
      tmp_3.a4k_1 = add(tmp_4, $this.x4j_1.s4f(tmp_5 instanceof Buffer() ? tmp_5 : THROW_CCE(), nextMatch));
      var tmp_6 = flushIfNeeded($this.v4j_1, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      return Unit_instance;
    }
  }
  return Unit_instance;
}
function advanceToNextPotentialMatch($this, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_advanceToNextPotentialMatch__2ypy7x.bind(VOID, $this), $completion);
}
function *_generator_checkFullMatch__turpx6($this, $completion) {
  $l$loop: while (true) {
    var tmp;
    if (!$this.x4j_1.z3x()) {
      tmp = true;
    } else {
      var tmp_0 = $this.t4j_1.q4j(VOID, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      tmp = tmp_0;
    }
    if (!tmp) {
      break $l$loop;
    }
    var byte = $this.x4j_1.i3y();
    if ($this.b4k_1 > 0 && !(byte === $this.u4j_1.w2($this.b4k_1))) {
      var oldMatchIndex = $this.b4k_1;
      while ($this.b4k_1 > 0 && !(byte === $this.u4j_1.w2($this.b4k_1))) {
        $this.b4k_1 = $this.y4j_1[$this.b4k_1 - 1 | 0];
      }
      var retained = fromInt(oldMatchIndex - $this.b4k_1 | 0);
      checkBounds($this, retained);
      var tmp_1 = $this;
      var tmp_2 = $this.a4k_1;
      var tmp_3 = $this.v4j_1.k4j();
      tmp_1.a4k_1 = add(tmp_2, $this.z4j_1.s4f(tmp_3 instanceof Buffer() ? tmp_3 : THROW_CCE(), retained));
      if ($this.b4k_1 === 0 && !(byte === $this.u4j_1.w2($this.b4k_1))) {
        var tmp_4 = writeByte($this.v4j_1, byte, $completion);
        if (tmp_4 === get_COROUTINE_SUSPENDED())
          tmp_4 = yield tmp_4;
        var _unary__edvuaz = $this.a4k_1;
        $this.a4k_1 = add(_unary__edvuaz, get_ONE());
        return false;
      }
    }
    $this.b4k_1 = $this.b4k_1 + 1 | 0;
    if ($this.b4k_1 === $this.u4j_1.v2()) {
      return true;
    }
    $this.z4j_1.i4g(byte);
  }
  return false;
}
function checkFullMatch($this, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_checkFullMatch__turpx6.bind(VOID, $this), $completion);
}
function checkBounds($this, extra) {
  if (add($this.a4k_1, extra) > $this.w4j_1) {
    throw IOException().s4h('Limit of ' + $this.w4j_1.toString() + ' bytes exceeded ' + ('while searching for "' + toSingleLineString($this, $this.u4j_1) + '"'));
  }
}
function toSingleLineString($this, _this__u8e3s4) {
  return replace(decodeToString(_this__u8e3s4), '\n', '\\n');
}
var ByteChannelScannerClass;
function ByteChannelScanner() {
  if (ByteChannelScannerClass === VOID) {
    class $ {
      constructor(channel, matchString, writeChannel, limit) {
        limit = limit === VOID ? 9223372036854775807n : limit;
        this.t4j_1 = channel;
        this.u4j_1 = matchString;
        this.v4j_1 = writeChannel;
        this.w4j_1 = limit;
        // Inline function 'kotlin.require' call
        if (!(this.u4j_1.v2() > 0)) {
          var message = 'Empty match string not permitted for scanning';
          throw IllegalArgumentException().s2(toString(message));
        }
        this.x4j_1 = this.t4j_1.h4j();
        this.y4j_1 = buildPartialMatchTable(this);
        this.z4j_1 = new (Buffer())();
        this.a4k_1 = 0n;
        this.b4k_1 = 0;
      }
      c4k(ignoreMissing, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_findNext__stdkn8.bind(VOID, this, ignoreMissing), $completion);
      }
    }
    initMetadataForClass($, 'ByteChannelScanner', VOID, VOID, VOID, [1, 0]);
    ByteChannelScannerClass = $;
  }
  return ByteChannelScannerClass;
}
//region block: exports
export {
  ByteChannelScanner as ByteChannelScanner1h148q1m3y1ey,
};
//endregion

//# sourceMappingURL=ByteChannelScanner.mjs.map
